import type { SiteSettingsProductDisclaimer } from "@diality/contracts";

/** Resolve the old sentinel only when no actual page owns that identity. */
export function bootstrapPageDisclaimers(
  entries: SiteSettingsProductDisclaimer[],
  pages: { id: string; url: string }[],
): SiteSettingsProductDisclaimer[] {
  if (pages.some((page) => page.id === "product")) return entries;
  const productPage = pages.find((page) => page.url === "/product");
  if (!productPage || entries.some((entry) => entry.pageId === productPage.id))
    return entries;
  return entries.map((entry) =>
    entry.pageId === "product" ? { ...entry, pageId: productPage.id } : entry,
  );
}

/** Render only the notice assigned to the current stable page identity. */
export function findPageDisclaimer(
  entries: SiteSettingsProductDisclaimer[],
  pageId: string | null | undefined,
): SiteSettingsProductDisclaimer | undefined {
  if (!pageId) return undefined;
  return entries.find((entry) => entry.pageId === pageId);
}
